export default __webpack_public_path__ + "12d8ef7760e3a7a143ce1f0b9c76bbdc.woff2";